import React, { useCallback } from 'react';
import BookCard from '../../components/BookCard';

export const StageBookCard = ({bookCard, id, storeMutate})=>{
    const onFinish = useCallback(()=>{
        if(storeMutate.isPending)return;
        storeMutate.mutate( {meeting_id:id, type:'card', content:"card 완료"} );
    }, [id, storeMutate]);

    return (
        <div data-aos="fade-right" data-aos-duration="1000" className="meetingBookCardContainer text-center">
            <div className="text"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/meeting_text.png`} alt=""/></div>
            <BookCard list={bookCard} onFinish={onFinish} />
        </div>
    );
}
